import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';

import { Container } from '@/atoms';

import InformationFields from '/public/images/informacion-datos-producto.png'
import Image from "next/image";

export function PopUpContact({ onClose, isOpen = true }) {

  return (
    <>
      <Dialog
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={onClose()}
        open={isOpen}
        transition
      >
        <div className="flex items-center justify-center min-h-screen px-4 text-center md:w-full bg-neutral-900 ">

          <DialogBackdrop transition className="fixed inset-0 bg-black ease-out duration-300 opacity-80 transition data-[closed]:opacity-0 data-[leave]:ease-in data-[leave]:duration-200" />

          <span
            className="inline-block md:h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <DialogPanel transition className="inline-block w-full md:w-[800px] md:h-[400px] transform  bg-white text-left md:align-middle shadow-xl transition-all data-[closed]:opacity-0 data-[closed]:scale-95 data-[leave]:ease-in data-[leave]:duration-200">

            <div className="w-full h-full p-1 md:p-6 pt-0">
              <Container
                wrapper
                padding="pt-2"
                backgroundColor="bg-white"
              >
                <div className="modal-header flex flex-shrink-0 justify-end">
                  <button
                    type="button"
                    className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={onClose()}
                  >
                    x
                  </button>
                </div>
                <div>
                  <Image src={InformationFields} alt="Información de datos del producto" className="w-full h-auto object-cover" />
                </div>
              </Container>
            </div>
          </DialogPanel>
        </div >
      </Dialog >
    </>
  );
};

